<template>
    <LayoutDashboard title="Funcionários">
        <v-card outlined>
            <v-card-title>
                <v-btn color="primary" @click="cadastrarFuncionario" outlined v-if="$helper.verificaPermissao('cadastrar-funcionario')">Cadastrar</v-btn>
                <v-spacer></v-spacer>
                <v-text-field outlined dense v-model="search" append-icon="search" label="Pesquisar" single-line hide-details>
                </v-text-field>
            </v-card-title>
            <v-card-text>
                <v-data-table :headers="headers" :items="getFuncionarios" :search="search" dense>
                    <template v-slot:item.action="{ item }">
                        <v-btn color="primary" outlined small @click="visualizarFuncionario(item)" v-if="$helper.verificaPermissao('visualizar-funcionario')">Visualizar</v-btn>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <ModalCadastroFuncionario />
    </LayoutDashboard>
</template>

<script>
    import ModalCadastroFuncionario from "@/pages/funcionario/ModalCadastro"
    import { mapGetters, mapActions } from "vuex"

    export default {
        components: {
            ModalCadastroFuncionario
        },
        data() {
            return {
                search: '',
                headers: [
                    { text: '#', value: 'id', sortable: false },
                    { text: 'Nome', align: 'left', sortable: false, value: 'nome'},
                    { text: 'CPF/CNPJ', value: 'cpf_cnpj'},
                    { text: 'Perfil', value: 'perfil.perfil'},
                    { text: 'Ações', value: 'action', sortable: false }
                ],
                funcionarios: [],
            }
        },
        computed: {
            ...mapGetters([
                'getFuncionarios'
            ])
        },
        methods: {
            ...mapActions([
                'listarFuncionarios',
                'visualizarFuncionario',
                'cadastrarFuncionario',
            ])
        },
        created() {
            this.listarFuncionarios()
        }
    }
</script>